const state = {
  groupList: [],
};

export default state;
